import React, { useState, useEffect, useReducer, useCallback } from "react";
import ApiService from "../ApiService";
import moment from "moment";
import { Col, Row, Spinner, Container, Card, OverlayTrigger, Tooltip, Button, Modal, Form } from "react-bootstrap";
import MessageDetail from "./MessageDetail";
import { BsArrowLeft, BsArrowClockwise, BsEnvelopeX, BsFillCheckCircleFill, BsHourglassSplit, BsFillExclamationCircleFill } from "react-icons/bs";
import { Healing,SupervisedUserCircleOutlined } from "@material-ui/icons";
import { PortraitSharp } from "@material-ui/icons";
import MaterialTable, { MTableFilterRow } from "material-table";
import { validClinicianLicenseStates } from "../util/licence-util";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import HumanReadableHours from "../util/humanReadableTime";
import { DateTime } from "luxon";
import { clinicianIdFromRefreshAuth } from "../util/authUtil";
import ERXModal from "./Modal/eRx/ERXModal";
import ErxService from "../service/erxService";

let isReloadMessagesInProgress = false;
const Message = props => {
  const [messages, setmessages] = useState(null);
  const [myStateMessages, setMyStateMessages] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState(null);
  const [messageUUID, setMessageUUID] = useState(null);
  const [goBack, setGoBack] = useState(false);
  const [allStatesShow, setAllStatesShow] = useState(true);
  const [showOnlyPatientMsgs, setShowOnlyPatientMsgs] = useState(false);
  const [showSentToMeOnly, setShowSentToMeOnly] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [statusMessages, setStatusMessages] = useState(null);
  const [showErxModal, setShowErxModal] = useState(false);
  const [eRxid, setERxId] = useState("");

  const [closeConvModal, setCloseConvModal] = useState(false);
  const [closeConvList, setCloseConvList] = useState(null);
  const [closingInfo, setClosingInfo] = useState(null);
  const [status, setStatus] = useState("");
  const [readMessageIds, setReadMessageIds] = useState([]);

  const handleCloseConvModal = () => {
    setCloseConvModal(false);
  };

  const handleCloseConversations = async (status, reason, loader) => {
    try {
      loader(true);
      if (!status || !reason) return handleSnackOpen("Please enter a reason", "error");
      let msgIds = closeConvList.map(item => item.messageUUID).join(",");
      await ApiService.addAnnotationToMessage({
        comment: reason,
        status: status,
        msgIds
      });
      handleSnackOpen(`Status changed to ${status} successfully`, "success");
      setCloseConvModal(false);
      setCloseConvList(null);
      setMode(null);
      getMessages();
    } catch (ex) {
      console.log("error", ex);
      handleSnackOpen("Something went wrong", "error");
    } finally {
      loader(false);
    }
  };

  const filterFromStatus = async status => {
    try {
      setStatus(status);
      let filteredMessages = [];
      if (allStatesShow === true) {
        filteredMessages = messages.filter(message => message?.latestStatus === status);
      } else if (allStatesShow === false) {
        filteredMessages = myStateMessages.filter(message => message?.latestStatus === status);
      }
      setStatusMessages(filteredMessages);
      handleSnackOpen(`Showing all conversations with status ${status}`, "info");
      getMessages();
    } catch (ex) {
      console.log("error", ex);
      handleSnackOpen("Something went wrong", "error");
    }
  };

  const clearStatusFilter = async () => {
    try {
      setStatus("");
      setStatusMessages(null);
      handleSnackOpen(`Cleared Status Filter`, "info");
      getMessages();
    } catch (ex) {
      console.log("error", ex);
      handleSnackOpen("Something went wrong", "error");
    }
  };

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  async function getMessages() {
    try {
      const getMessages = await ApiService.getMessages();
      //`0 Rearrange the data, bring all objects with repliedBy===null to the top
      getMessages.data.sort((a, b) => {
        if (a.repliedBy === null && b.repliedBy !== null) return -1;
        if (a.repliedBy !== null && b.repliedBy === null) return 1;
        return 0;
      });
      //` 1: Set All Messages
      setmessages(getMessages.data);
      //` 2: Set My State Messages
      const validStates = await validClinicianLicenseStates().then(res => res);
      const myMessages = getMessages.data.filter(message => {
        return validStates.includes(message.state);
      });
      setMyStateMessages(myMessages);
      if (isReloadMessagesInProgress) {
        props.updateReloadInboxMessages();
        isReloadMessagesInProgress = false;
      }
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoading(false);
    }
  }

  // console.log("messages", messages)

  useEffect(() => {
    getMessages().then(r => r);
    setLoading(true);
  }, []);

  useEffect(() => {
    if (props.goBack !== goBack) {
      setMode(null);
      setGoBack(!goBack);
    }
  }, [props.goBack]);

  useEffect(() => {
    if (props.reloadInboxMessages && !isReloadMessagesInProgress) {
      isReloadMessagesInProgress = true;
      getMessages();
    }
  }, [props.reloadInboxMessages]);

  function fetchMessage(messageUUID) {
    const existingReadMessageIds = [...readMessageIds];
    if (existingReadMessageIds && !existingReadMessageIds.includes(messageUUID)) {
      existingReadMessageIds.push(messageUUID);
      setReadMessageIds(existingReadMessageIds);
    }
    const MessageDetailsUrl = `${process.env.REACT_APP_BASE_URL}/MessageDetails?messageId=${messageUUID}`;
    window.open(MessageDetailsUrl, "_blank");
  }

  function reduce() {
    props.reduce();
  }

  const showAllStateMessages = () => {
    handleSnackOpen("Showing all messages", "success");
    setAllStatesShow(true);
  };

  const showMyStateMessages = () => {
    handleSnackOpen("Showing messages for your state", "info");
    setAllStatesShow(false);
  };

  const getMessagesToRender = () => {
    let returnMsgs = [];
    returnMsgs = allStatesShow ? messages : myStateMessages;

    if (showOnlyPatientMsgs) {
      returnMsgs = returnMsgs?.filter(m => {
        return m?.fromActorType?.toUpperCase() === "PATIENT";
      });
    }

    if (showSentToMeOnly) {
      returnMsgs = returnMsgs?.filter(m => {
        return m?.sentToMe === true;
      });
    }
    return returnMsgs;
  };

  const getStatusColVal = rowData => {
    //feature was rolled out in backend on 01-Mar-2023 with no retro fitting older messages
    //hence return not applicable
    // if(DateTime.fromISO(rowData.createdDateTime).toSeconds() < 1677703741) return (<span>Tracking unavailable</span>);
    if (rowData?.latestStatus === "DONE")
      return (
        <span style={{ color: "#266400" }}>
          <b>DONE</b>
        </span>
      );
    if (rowData?.latestStatus === "IN_PROGRESS")
      return (
        <span style={{ color: "#BA8719" }}>
          <b>IN PROGRESS</b>
        </span>
      );
    if (rowData?.latestStatus === "NEEDS_REVIEW")
      return (
        <span style={{ color: "#FA2F2F" }}>
          <b>NEEDS REVIEW</b>
        </span>
      );
    return <span></span>;
  };

  const localization = {
    toolbar: {
      nRowsSelected: "{0} conversation(s) selected"
    }
  };

  const hideErxModal = (orderCreated = false) => {
    setShowErxModal(false);
    if (orderCreated) {
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Prescription Sent!");
    }
  };
  const handleOpenPrescriptionModal = async (event, rowData) => {
    try {
      const getMessage = await ApiService.getMessage(messageUUID);
      let userData;
      if (getMessage?.data?.fromUser?.addresseeType == "PATIENT") {
        userData = getMessage?.data?.fromUser;
      } else {
        userData = getMessage?.data?.toUsers?.find(item => item.addresseeType == "PATIENT");
      }

      const userDetailRes = await ApiService.getPatientDetailByEmail(userData?.email);
      const userDetail = userDetailRes?.data;
      const photonHealthErxPatientId = userDetailRes?.data?.photonHealthErxPatientId;

      if (photonHealthErxPatientId) {
        setShowErxModal(true);
        setERxId(photonHealthErxPatientId);
      } else {
        if (!userDetail?.birthDate) {
          setSnackOpen(true);
          setSnackSeverity("error");
          setSnackText("Patient DOB is missing");
          return;
        }
        const sexAtBirth = ErxService.determineSexAtBirth(userDetail?.genderAtBirth ?? userDetail?.gender);
        const eRxIdRes = await ApiService.createPatientOnPhoton({
          patientId: userDetail?.subUUID,
          firstName: userDetail?.givenName,
          lastName: userDetail?.familyName,
          dob: userDetail?.birthDate,
          sex: sexAtBirth,
          gender:userDetail?.gender,
          phone: userDetail?.phoneNumber,
          email: userDetail?.email,
          address: {
            name: {
              first: userDetail?.givenName,
              last: userDetail?.familyName
            },
            street1: userDetail?.address?.street_address,
            street2: userDetail?.address?.street_address2,
            postalCode: userDetail?.address?.postal_code,
            country: "USA",
            state: userDetail?.address?.region,
            city: userDetail?.address?.locality
          }
        });
        if (eRxIdRes?.data?.erxPhotonId?.id) {
            const res = await ApiService.updatePhotonERxPatientId(userDetail?.subUUID, eRxIdRes?.data?.erxPhotonId?.id);
          if (res) {
            setShowErxModal(true);
            setERxId(eRxIdRes?.data?.erxPhotonId?.id);
          }
        }
      }
    } catch (err) {
      console.log("err", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  const onClickViewProfile = async (event, rowData) => {
    try {
      const getMessage = await ApiService.getMessage(messageUUID);
      let userData;
      if (getMessage?.data?.fromUser?.addresseeType == "PATIENT") {
        userData = getMessage?.data?.fromUser;
      } else {
        userData = getMessage?.data?.toUsers?.find(item => item.addresseeType == "PATIENT");
      }
      if (!userData?.userId) {
        const belugaPatientEmail = getMessage?.data?.from;
        const email = belugaPatientEmail.substring(belugaPatientEmail.indexOf("(") + 1, belugaPatientEmail.indexOf(")"));
        console.log("email", email);
        if (!email) {
          setSnackOpen(true);
          setSnackSeverity("error");
          setSnackText("Patient email is missing");
          return;
        }
        const userDetailRes = await ApiService.getPatientDetailByEmail(email);
        console.log("userDetailRes", userDetailRes);
        userData = { ...userDetailRes?.data, userId: userDetailRes?.data?.subUUID };
      }
      console.log("userData", userData);
      window.open(`/PatientProfile?patientId=${userData?.userId}&idType=sub`, "_blank");
    } catch (err) {
      console.log("err", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  //& VIEW
  if (loading) {
    return (
      <Row>
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </Row>
    );
  } else if (!loading && mode !== "VIEW_MESSAGE_DETAIL") {
    return (
      <Container fluid>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: 200,
                height: 45,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                background: "white",
                paddingInline: 12,
                borderRadius: 8,
                marginBottom: 12
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    backgroundColor: allStatesShow ? "rgba(151, 71, 255, 0.40)" : "white",
                    borderRadius: 5,
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                    fontWeight: allStatesShow ? "800" : "400"
                  }}
                  onClick={showAllStateMessages}
                >
                  All States
                </div>
              </div>

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    backgroundColor: !allStatesShow ? "rgba(151, 71, 255, 0.40)" : "white",
                    borderRadius: 5,
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                    fontWeight: !allStatesShow ? "800" : "400"
                  }}
                  onClick={showMyStateMessages}
                >
                  My States
                </div>
              </div>
            </div>
            <div
              style={{
                width: 400,
                height: 45,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                background: "white",
                paddingInline: 12,
                borderRadius: 8,
                marginBottom: 12,
                marginLeft: 12
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    backgroundColor: !showOnlyPatientMsgs ? "rgba(151, 71, 255, 0.40)" : "white",
                    borderRadius: 5,
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                    fontWeight: showOnlyPatientMsgs ? "400" : "800"
                  }}
                  onClick={() => {
                    setShowOnlyPatientMsgs(false);
                  }}
                >
                  All Messages
                </div>
              </div>

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    backgroundColor: showOnlyPatientMsgs ? "rgba(151, 71, 255, 0.40)" : "white",
                    borderRadius: 5,
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                    fontWeight: showOnlyPatientMsgs ? "800" : "400"
                  }}
                  onClick={() => {
                    setShowOnlyPatientMsgs(true);
                  }}
                >
                  Unanswered Messages
                </div>
              </div>
            </div>

            {/* */}
            <div
              style={{
                width: 280,
                height: 45,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                background: "white",
                paddingInline: 12,
                borderRadius: 8,
                marginBottom: 12,
                marginLeft: 12
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    backgroundColor: !showSentToMeOnly ? "rgba(151, 71, 255, 0.40)" : "white",
                    borderRadius: 5,
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                    fontWeight: showSentToMeOnly ? "400" : "800"
                  }}
                  onClick={() => {
                    setShowSentToMeOnly(false);
                  }}
                >
                  All Messages
                </div>
              </div>

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    backgroundColor: showSentToMeOnly ? "rgba(151, 71, 255, 0.40)" : "white",
                    borderRadius: 5,
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                    fontWeight: showSentToMeOnly ? "800" : "400"
                  }}
                  onClick={() => {
                    setShowSentToMeOnly(true);
                  }}
                >
                  Sent to me
                </div>
              </div>
            </div>

            {/* */}
          </div>

          {closeConvList?.length >= 1 && (
            <Button
              variant="light"
              style={{
                width: "auto",
                height: 45,
                color: "white",
                background: "#007F61",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
                border: "none"
              }}
              onClick={() => setCloseConvModal(true)}
            >
              <BsEnvelopeX />
              &nbsp;&nbsp;Update Status
            </Button>
          )}
        </div>

        {messages?.length ? (
          <MaterialTable
            columns={[
              {
                title: "Sender",
                field: "from"
              },
              {
                title: "Subject",
                field: "subject",
                cellStyle: {
                  width: 500,
                  maxWidth: 500
                }
              },
              {
                title: "Date/Time",
                field: "createdDateTime",
                render: rowData => <span>{moment(rowData?.createdDateTime).format("ddd MMM D, YYYY LT")}</span>
              },
              {
                title: "Status",
                field: "latestStatus",
                render: rowData => getStatusColVal(rowData),
                cellStyle: {
                  width: 400,
                  maxWidth: 400
                }
              },
              {
                title: "Dob",
                field: "patientDob",
                render: rowData => <span>{rowData?.patientDob}</span>
              },
              {
                title: "State",
                field: "state",
                render: rowData => <span>{rowData?.state}</span>
              },
              {
                title: "Recipients",
                field: "to",
                render: rowData => <span>{rowData?.to}</span>
              }
            ]}
            data={getMessagesToRender()}
            onRowClick={(event, rowData) => {
              if (rowData?.unread) {
                fetchMessage(rowData?.messageUUID);
                reduce();
              } else {
                fetchMessage(rowData?.messageUUID);
              }
            }}
            onSelectionChange={rows => {
              if (rows.length >= 1) {
                setCloseConvList(rows);
              } else {
                setCloseConvList([]);
              }
            }}
            localization={localization}
            options={{
              selection: true,
              selectionProps: rowData => ({
                disabled: rowData?.repliedBy ? true : false
              }),
              filtering: true,
              exportButton: true,
              headerStyle: {
                position: "sticky",
                top: 0,
                color: "black"
              },
              maxBodyHeight: "630px",
              search: true,
              pageSize: 100,
              pageSizeOptions: [50, 100, 200, 500],
              emptyRowsWhenPaging: false,
              draggable: false,
              showTitle: true,
              toolbarButtonAlignment: "right",
              exportAllData: true,
              doubleHorizontalScroll: true,
              sorting: true,
              rowStyle: rowData => {
                const style = {
                  backgroundColor: rowData?.unread && !readMessageIds.includes(rowData?.messageUUID) ? "#e4e4e4" : "#FFFFFF",
                  color: "black",
                  border: true,
                  fontWeight: rowData?.unread && !readMessageIds.includes(rowData?.messageUUID) ? "bold" : "normal"
                };
                return style;
              }
            }}
            title="Inbox"
            components={{
              FilterRow: props => {
                return <MTableFilterRow {...props} />;
              }
            }}
          />
        ) : (
          <div className="no-message">
            <h3>No messages found</h3>
          </div>
        )}
        <Snackbar open={snackOpen} autoHideDuration={2500} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert onClose={handleSnackClose} severity={snackSeverity}>
            {snackText}
          </Alert>
        </Snackbar>

        <ConfirmationModal show={closeConvModal} handleClose={handleCloseConvModal} handleConfirm={handleCloseConversations} />
      </Container>
    );
  } else if (mode === "VIEW_MESSAGE_DETAIL") {
    return (
      <>
        <Card body className="CardFullBody">
          <Card.Body className="messageDetailBody">
            <Col>
              <div
                style={{
                  width: "100%",
                  fontSize: "1vw",
                  display: "inline-flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 6
                }}
              >
                <div>
                  <Button
                    variant="primary"
                    style={{
                      width: "auto",
                      height: 35,
                      background: "#007F61",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: "bold",
                      border: "none"
                    }}
                    onClick={() => {
                      handleOpenPrescriptionModal();
                    }}
                  >
                    <Healing
                      style={{
                        color: "white"
                      }}
                    />
                    &nbsp;&nbsp;Send Prescription
                  </Button>
                  <div style={{ display: "inline-flex", opacity: closingInfo?.latestStatus ? 1 : 0 }}>
                    Status : <StatusDone status={closingInfo?.latestStatus} />
                  </div>
                </div>
                <div>
                <Button
                    variant="primary"
                    style={{
                      width: "auto",
                      height: 35,
                      background: "#007F61",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: "bold",
                      border: "none",
                      marginRight: 10,
                    }}
                    onClick={() => {
                      onClickViewProfile();
                    }}
                  >
                    <SupervisedUserCircleOutlined
                      style={{
                        color: "white"
                      }}
                    />
                    &nbsp;&nbsp;View Profile
                  </Button>
                <Button
                  variant="primary"
                  style={{
                    width: "auto",
                    height: 35,
                    background: "#007F61",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    border: "none"
                  }}
                  onClick={() => setCloseConvModal(true)}
                >
                  <BsArrowClockwise />
                  &nbsp;&nbsp;Update Status
                </Button>
                </div>
              </div>
              <br />
              {closingInfo && (
                <Form.Label style={{ width: "100%", fontSize: "1vw", display: "inline-flex", justifyContent: "flex-start", alignItems: "center" }}>
                  <div>
                    Comment :&nbsp;<b>{closingInfo?.latestComment}</b>
                  </div>
                  &nbsp;&nbsp;-&nbsp;&nbsp;
                  <div>
                    Author :&nbsp;<b>{closingInfo?.latestCommentBy}</b>
                  </div>
                </Form.Label>
              )}
              <hr />
            </Col>
            <span className="go-back-wrap" onClick={() => setMode(null)}>
              <BsArrowLeft />
            </span>
            <MessageDetail messageUUID={messageUUID} setClosingInfo={setClosingInfo} />
          </Card.Body>
        </Card>
        <Snackbar open={snackOpen} autoHideDuration={2500} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert onClose={handleSnackClose} severity={snackSeverity}>
            {snackText}
          </Alert>
        </Snackbar>

        <ConfirmationModal show={closeConvModal} handleClose={handleCloseConvModal} handleConfirm={handleCloseConversations} />
        {showErxModal && <ERXModal show={showErxModal} onHide={hideErxModal} eRxid={eRxid} />}
      </>
    );
  }
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ConfirmationModal = ({ show, handleClose, handleConfirm }) => {
  const [status, setStatus] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  return (
    <Modal show={show} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Body>
        <p>Are you sure want to update status?</p>
        <div key={`default-radio`} className="mb-3">
          <Form.Check
            type={"radio"}
            label={`Needs Review`}
            value="NEEDS_REVIEW"
            checked={status === "NEEDS_REVIEW"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
          <Form.Check
            type={"radio"}
            label={`In Progress`}
            value="IN_PROGRESS"
            checked={status === "IN_PROGRESS"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
          <Form.Check
            type={"radio"}
            label={`Done`}
            value="DONE"
            checked={status === "DONE"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
        </div>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Reason for this status?</Form.Label>
          <Form.Control as="textarea" rows={3} placeholder="Type in the reason" onChange={e => setReason(e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="secondary" onClick={handleClose}>
          CLOSE
        </Button>
        <Button
          variant="light"
          disabled={loading}
          style={{
            width: "auto",
            color: "white",
            background: "#007F61",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            border: "none"
          }}
          onClick={() => handleConfirm(status, reason, setLoading)}
        >
          CONFIRM
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const StatusDone = ({ status }) => {
  return (
    <div
      style={{
        width: "auto",
        height: 30,
        color: "white",
        background: status === "DONE" ? "#007F61" : status === "IN_PROGRESS" ? "#BA8719" : status === "NEEDS_REVIEW" ? "#FA2F2F" : "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        border: "none",
        borderRadius: 5,
        paddingInline: 10,
        fontSize: "1vw",
        marginLeft: 10
      }}
    >
      {status === "DONE" ? (
        <BsFillCheckCircleFill />
      ) : status === "IN_PROGRESS" ? (
        "In Progress"
      ) : status === "NEEDS_REVIEW" ? (
        <BsFillExclamationCircleFill />
      ) : null}
      &nbsp;&nbsp;{status === "DONE" ? "Done" : status === "IN_PROGRESS" ? <BsHourglassSplit /> : status === "NEEDS_REVIEW" ? "Needs Review" : null}
    </div>
  );
};

export default Message;
